import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import './officelocation.scss';
import { ReactComponent as Back } from '../../images/back.svg';
import base from '../../apis';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
import Modal from '../../components/Modal/Modal';
import NotificationModal from '../../components/NotificationModal/NotificationModal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { GoLinkExternal } from 'react-icons/go';
import Select from 'react-select';
import { sizeOptions } from '../../constants';

const selectStyles = {
  container: (provided) => ({
    ...provided,
    flex: 1,
  }),
};

function OfficeLocations() {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [officeDetails, setOfficeDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const OFFICES = useRef([]);
  const [CITIES, setCITIES] = useState([]);
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const { name } = useLocation().state;
  const [searchParams, setSearchParams] = useState({
    city: {
      value: '',
      label: '',
    },
    size: {
      value: '',
      label: '',
    },
    address: '',
    name: '',
  });
  const [newOfficeDetails, setNewOfficeDetails] = useState({
    branch: '',
    phone: '',
    city: '',
    address: '',
    web_link: '',
    size: 'Small',
    state: 'Ca',
    location: 'Northern Ca',
    manager_name: '',
    manager_email: '',
    manager_phone: '',
    zip_code: '',
  });

  const [isNew, setIsNew] = useState(true);

  const onChangeNewDetails = (e) => {
    const { name, value } = e.target;
    setNewOfficeDetails({ ...newOfficeDetails, [name]: value });
  };

  const getOffices = React.useCallback(() => {
    setIsLoading(true);
    base
      .get(`/operations/companies/${companyId}/`)
      .then((res) => {
        setIsLoading(false);
        setOfficeDetails(res.data);
        OFFICES.current = res.data;
        OFFICES.current = res.data;

        const cities = res.data?.offices?.map((item) => item.city);
        setCITIES([...new Set(cities)].map((item) => ({ value: item, label: item })));
        if (res.data?.offices.length === 0) {
          toast.warn('No offices found');
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error('Error Loading Offices');
      });
  }, [companyId]);

  useEffect(() => {
    setIsLoading(true);
    setOfficeDetails(null);
    getOffices();
  }, [companyId, getOffices]);

  const onSearchEnter = (e, option) => {
    if (option) {
      setSearchParams({ ...searchParams, [option]: e });
      return;
    }

    const { value, name } = e.target;
    setSearchParams((prev) => ({ ...prev, [name]: value }));
  };

  const addNewOffice = (e) => {
    e.preventDefault();

    setIsLoading(true);
    base
      .post('/operations/offices/', {
        ...newOfficeDetails,
        company_id: companyId,
      })
      .then((res) => {
        setIsLoading(false);
        setAddNewModalOpen(false);
        setSearchParams({
          city: {
            value: '',
            label: '',
          },
          size: {
            value: '',
            label: '',
          },
          address: '',
          name: '',
        });
        setToastOpen(true);
        setTimeout(() => {
          setToastOpen(false);
          getOffices();
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error('Error Adding Office');
      });

    return;

    //open toast
  };

  const onSearch = (e) => {
    e.preventDefault();
    const { city, size, address, name } = searchParams;
    if (!city?.value && !size?.value && !address && !name) {
      setOfficeDetails(OFFICES.current);
      return;
    }
    const filteredOffices = OFFICES.current.offices.filter((office, index) => {
      if (city?.value && office.city?.toLowerCase() !== city?.value?.toLowerCase()) {
        return false;
      }
      if (size?.value && office.size !== size?.value) {
        return false;
      }
      if (address && !office.address?.toLowerCase().includes(address?.toLowerCase())) {
        return false;
      }
      if (name && !office.branch?.toLowerCase().includes(name?.toLowerCase())) {
        return false;
      }
      return true;
    });

    setOfficeDetails({ ...OFFICES.current, offices: filteredOffices });
  };

  const openAddNew = () => {
    setAddNewModalOpen(true);
    setIsNew(true);
    setNewOfficeDetails({
      branch: '',
      phone: '',
      city: '',
      address: '',
      web_link: '',
      size: 'S',
      state: 'Ca',
      location: 'Northern Ca',
      manager_name: '',
      manager_email: '',
      manager_phone: '',
      zip_code: '',
    });
  };

  const viewDetails = (office) => {
    setAddNewModalOpen(true);
    setIsNew(false);
    setNewOfficeDetails(office);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <Modal open={addNewModalOpen} style={{ minHeight: '80vh' }} onClose={() => setAddNewModalOpen(false)}>
        <div className="aomodal" style={{ height: 'unset' }}>
          <div className="modheader">
            <p
              style={{
                marginRight: 'auto',
                marginLeft: 'auto',
                fontSize: '24px',
                fontWeight: '700',
              }}>
              {isNew ? 'Add New Office' : 'Office Details'}
            </p>
            <CloseIcon
              style={{ fill: 'white', cursor: 'pointer' }}
              width="18px"
              height="18px"
              onClick={() => setAddNewModalOpen(false)}
            />
          </div>
          <fieldset style={{ all: 'unset' }} disabled={!isNew}>
            <form className="anoffice" onSubmit={addNewOffice}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  gap: '10px',
                }}>
                <div className="ethird">
                  <p>Broker Name</p>
                  <Input
                    style={{ textTransform: 'capitalize' }}
                    placeholder="Broker Name"
                    required
                    autoFocus
                    name="branch"
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.branch || ''}
                  />
                </div>
                <div style={{ width: '40%' }}>
                  <span>Telephone Number</span>
                  <Input
                    required
                    placeholder="Telephone Number"
                    type="tel"
                    name="phone"
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.phone || ''}
                  />
                </div>
              </div>
              <p>Broker Office Location</p>
              <div className="div">
                <div>
                  <span>City</span>
                  <Input
                    style={{ textTransform: 'capitalize' }}
                    required
                    placeholder="City"
                    name="city"
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.city || ''}
                  />
                </div>
                <div>
                  <span>Address</span>
                  <Input
                    style={{ textTransform: 'capitalize' }}
                    required
                    placeholder="Address"
                    name="address"
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.address || ''}
                  />
                </div>
                <div style={{ width: '10%' }}>
                  <span>Zip Code</span>
                  <Input
                    required
                    placeholder="Zip Code"
                    name="zip_code"
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.zip_code || ''}
                  />
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  gap: '10px',
                  justifyContent: 'space-between',
                }}>
                <div className="ethird" style={{ width: '60%' }}>
                  <p>
                    Broker Office Website Link{' '}
                    {!isNew && (
                      <a href={newOfficeDetails.web_link} rel="noreferrer" target="_blank">
                        <GoLinkExternal className="linker" title="Click to go to website" />
                      </a>
                    )}
                  </p>
                  <Input
                    type="url"
                    placeholder="Enter website address"
                    name="web_link"
                    required
                    onChange={onChangeNewDetails}
                    value={newOfficeDetails.web_link || ''}
                  />
                </div>
                <div>
                  <p>Office Size</p>
                  <select required onChange={onChangeNewDetails} name="size" value={newOfficeDetails.size}>
                    <option value="S">Small</option>
                    <option value="M">Medium</option>
                    <option value="L">Large</option>
                    <option value="XL">Extra Large</option>
                  </select>
                </div>
                <div>
                  <p>Office Location</p>
                  <select required value={newOfficeDetails.location} name="location" onChange={onChangeNewDetails}>
                    <option>Northern CA</option>
                    <option>Southern CA</option>
                  </select>
                </div>
              </div>
              <div className="evener">
                <div>
                  <span>Broker Manager Name</span>
                  <Input
                    required
                    placeholder="Broker Manager Name"
                    value={newOfficeDetails.manager_name || ''}
                    name="manager_name"
                    style={{ textTransform: 'capitalize' }}
                    onChange={onChangeNewDetails}
                  />
                </div>
                <div>
                  <span>Broker Manager Email</span>
                  <Input
                    required
                    placeholder="Broker Manager Email"
                    type="email"
                    value={newOfficeDetails.manager_email || ''}
                    name="manager_email"
                    onChange={onChangeNewDetails}
                  />
                </div>
                <div>
                  <span>Broker Manager Number</span>
                  <Input
                    required
                    placeholder="Broker Manager Number"
                    value={newOfficeDetails.manager_phone || ''}
                    name="manager_phone"
                    type="tel"
                    onChange={onChangeNewDetails}
                  />
                </div>
              </div>
              {isNew && (
                <Button
                  style={{
                    width: '100px',
                    fontSize: '16px',
                    padding: '10px',
                    color: 'white',
                    backgroundColor: 'var(--primary-color)',
                    display: 'block',
                    marginLeft: 'auto',
                  }}
                  text="Submit"
                  type="submit"
                />
              )}
            </form>
          </fieldset>
        </div>
      </Modal>
      <NotificationModal isOpen={toastOpen} message="New Office Added" />
      <div className="officeloc">
        <form className="modinputs" onSubmit={onSearch}>
          <Select
            placeholder="Select City"
            options={CITIES}
            isSearchable={true}
            name="size"
            onChange={(e) => onSearchEnter(e, 'city')}
            styles={selectStyles}
            isClearable={true}
          />
          <Select
            placeholder="Enter Office Size"
            options={sizeOptions}
            isSearchable={false}
            name="size"
            onChange={(e) => onSearchEnter(e, 'size')}
            styles={selectStyles}
            isClearable={true}
          />

          <Input
            placeholder="Enter Office Address"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            type="search"
            onChange={onSearchEnter}
            name="address"
          />
          <Input
            placeholder="Enter Office Name"
            style={{ fontSize: '16px', padding: '10px 20px' }}
            type="search"
            onChange={onSearchEnter}
            name="name"
          />
          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            text="Filter"
          />
        </form>
        <div className="ofnav">
          <Button
            style={{
              width: '150px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
              marginTop: 'unset',
            }}
            text="Add New Office"
            onClick={openAddNew}
          />
          <div>
            <Back onClick={() => navigate(-1)} />
            <span>{name}</span>
          </div>
        </div>
        <div className="itemholder">
          {officeDetails?.offices.map((office) => (
            <Item
              name={office.branch}
              key={office.id}
              {...office}
              onClick={() => {
                viewDetails(office);
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default OfficeLocations;

const Item = ({ name, address, onClick, id }) => {
  // const navigate = useNavigate();

  return (
    <div className="item" onClick={onClick} style={{ position: 'relative' }}>
      <p>{name}</p>
      <p>{address}</p>
    </div>
  );
};
